import React, { Component } from "react";
import axios from "axios";
import { withTranslation } from "react-i18next";
import "./shopReview.css";

class ShopReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [],
      place: null,
      loading: true,
      error: null,
      filter: null, // null = all, "google", "slotti"
    };
  }

  componentDidMount() {
    this.fetchReviews();
  }

  fetchReviews() {
    const apiUrl = `https://darkslateblue-mink-768848.hostingersite.com/api/reviews/ChIJmVHODdCHm0YRAgRhIuD0Q8M`;
    axios
      .get(apiUrl)
      .then((response) => {
        const data = response.data;
        const reviews = (data.reviews || []).filter(
          (r) => r.text && r.text.trim() !== ""
        );

        this.setState({
          reviews,
          place: data.place || null,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching reviews:", error);
        this.setState({ error: "Failed to load reviews", loading: false });
      });
  }

  getFilteredReviews() {
    const { reviews, filter } = this.state;
    let filtered = reviews;
    if (filter) {
      filtered = reviews.filter((r) => r.source === filter);
    }
    // Sort by time descending and take latest 5
    return filtered
      .slice()
      .sort((a, b) => (b.time || 0) - (a.time || 0))
      .slice(0, 5);
  }

  setFilter = (source) => {
    this.setState((prev) => ({
      filter: prev.filter === source ? null : source,
    }));
  };

  renderStars(rating) {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        stars.push(
          <span key={i} className="review-star filled">★</span>
        );
      } else if (i - rating < 1 && i - rating > 0) {
        stars.push(
          <span key={i} className="review-star half">★</span>
        );
      } else {
        stars.push(
          <span key={i} className="review-star empty">★</span>
        );
      }
    }
    return stars;
  }

  render() {
    const { t } = this.props;
    const { place, loading, error, filter } = this.state;
    const displayReviews = this.getFilteredReviews();

    if (loading) {
      return (
        <section className="review-section" id="reviews">
          <div className="container text-center">
            <div className="review-loading">
              <div className="spinner"></div>
            </div>
          </div>
        </section>
      );
    }

    if (error) {
      return null;
    }

    return (
      <section className="review-section" id="reviews">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">
                {t("reviewH.title")}
              </h2>
              <h3 className="review-section-subtitle">
                {t("reviewH.subtitle")}
              </h3>
            </div>
          </div>

              {/* Filter Buttons */}
          <div className="review-filter-bar">
            <button
              className={`review-filter-btn ${filter === "google" ? "active" : ""}`}
              onClick={() => this.setFilter("google")}
            >
              <img
                src="https://www.google.com/favicon.ico"
                alt="Google"
                className="review-filter-icon"
              />
              Google
                <span className="review-rating-value">{place.googleRating}</span>
                <span className="review-rating-count">({place.totalGoogleReviews})</span>
            </button>
            <button
              className={`review-filter-btn review-filter-btn-slotti ${filter === "slotti" ? "active" : ""}`}
              onClick={() => this.setFilter("slotti")}
            >
              <img
                src="https://play-lh.googleusercontent.com/Rw6DwyN33ElBJWrIIF3s7H76SDnznKnOQ7twMnE2UODtyLtugnBkC-pRSxCtzl52Hm60=w240-h480-rw"
                alt="Slotti"
                className="review-filter-icon"
              />
              Slotti
                <span className="review-rating-value">{place.slottiRating}</span>
                <span className="review-rating-count">({place.totalSlottiReviews})</span>

            </button>
          </div>

          {/* Review Grid */}
          <div className="review-grid">
            {displayReviews.map((review, index) => (
              <div className="review-card" key={review.id || index}>
                <div className="review-card-header">
                  <div className="review-author-avatar">
                    {review.profilePhotoUrl ? (
                      <img
                        src={review.profilePhotoUrl}
                        alt={review.authorName}
                        className="review-avatar-img"
                        referrerPolicy="no-referrer"
                      />
                    ) : (
                      <div className="review-avatar-placeholder">
                        {review.authorName
                          ? review.authorName.charAt(0).toUpperCase()
                          : "?"}
                      </div>
                    )}
                  </div>
                  <div className="review-author-info">
                    <span className="review-author-name">
                      {review.authorName}
                    </span>
                    <span className="review-time">
                      {review.timeStamp
                        ? new Date(review.timeStamp).toLocaleDateString()
                        : ""}
                    </span>
                  </div>
                </div>
                <div className="review-card-rating">
                  {this.renderStars(review.rating)}
                </div>
                <p className="review-card-text">{review.text}</p>
                <div className="review-card-footer">
                  {review.source === "slotti" ? (
                    <>
                      <img
                        src="https://play-lh.googleusercontent.com/Rw6DwyN33ElBJWrIIF3s7H76SDnznKnOQ7twMnE2UODtyLtugnBkC-pRSxCtzl52Hm60=w240-h480-rw"
                        alt="Slotti"
                        className="review-card-source-icon"
                      />
                      <span className="review-card-source-text">Slotti</span>
                    </>
                  ) : (
                    <>
                      <img
                        src="https://www.google.com/favicon.ico"
                        alt="Google"
                        className="review-card-source-icon"
                      />
                      <span className="review-card-source-text">Google</span>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation("global")(ShopReview);